import { validateZenodoRecord } from "../utilities/schemaValidation.js";
export class Record {
    value;
    zenodo;
    constructor(zenodo, value) {
        this.zenodo = zenodo;
        this.value = validateZenodoRecord(value);
    }
    async getDeposition() {
        if (this.value.id === undefined) {
            throw new Error('Deposition ID is undefined');
        }
        if (this.zenodo.accessToken === undefined) {
            throw new Error('Access token is required to retrieve a deposition');
        }
        return await this.zenodo.retrieveDeposition(this.value.id);
    }
}
//# sourceMappingURL=Record.js.map